import { Query, gql } from 'apollo-angular';
import { Injectable } from '@angular/core';


import { IPage } from '@collections/common/interfaces';
import { NewsStatusEnum, NewsTypeEnum } from '@collections/news/enums/news.enums';
import { newsFragment } from './fragments/news.fragment';
import { pageInfoFragment } from '../common/fragments/page-info.fragment';
import { INews } from '@collections/news/interfaces/news.interface';


export interface NewsResponse {
  news: IPage<INews>;
}

export interface NewsParams {
  lang: string;
  newsType: NewsTypeEnum;
  newsStatus: NewsStatusEnum;
  tag: string;
  search: string;
}

@Injectable()
export class NewsGQL extends Query<NewsResponse> {
  document = gql`
  query getNews ($first: Int, $after: String, $lang: String!, $newsType: String!, $newsStatus: String!,
                $unpublished: Boolean, $companyId: ObjectId, $tag: String, $search: String,
                $fieldsOfRelevance: [String!], $category: String) {
    news(first: $first, after: $after, lang: $lang, newsType: $newsType, newsStatus: $newsStatus, unpublished: $unpublished,
        companyId: $companyId, tag: $tag, search: $search, fieldsOfRelevance: $fieldsOfRelevance, category: $category) {
      totalCount
      edges {
        cursor
        node {
          ...news
          summary
        }
      }
      pageInfo {
        ...pageInfo
      }

    }
  }
  ${newsFragment},
  ${pageInfoFragment}
  `;
}
